@import '../UI/MarkdownContent/MarkdownTable.module.less';

// Emitted once for the whole app: the expanded-table modal renders in a portal
// at the document root, so its classes must be global and defined a single time.
.fl_markdown_table_modal();

.chatMessage {
    width: 100%;
    padding: 20px;
    min-height: 150px;
}

.chatmessage {
    background-color: transparent;
    border-radius: 5px;
    padding: 12px 16px;
    margin: 0;
    width: 100%;
    opacity: 0;
    animation: fadeIn 0.5s ease-in-out forwards;
}

.chatmessageUser {
    .chatmessage();
}

.chatmessageAI {
    .chatmessage();
}

.userBubble {
    background-color: #f1f7fe;
    border-radius: 8px;
    padding: 8px 16px;
    width: fit-content;
    max-width: 70%;
    align-self: flex-end;
    word-wrap: break-word;
}

.agentMessage {
    background-color: #e8f0fe !important;
    padding: 20px !important;
    border-radius: 10px !important;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.2));
}
// Text stays in a comfortable reading column; tables are full-width (they set
// their own width up to the inner-bg edge and scroll if wider).
@reading-width: 75%;

.aiContent {
    // Full width so tables can fill to the inner-bg edge. The reading-column
    // max-width below is applied to the text elements, not the whole block.
    width: 100%;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #323b48;
    line-height: 1.5;
    letter-spacing: -0.15px;

    // Compact markdown typography
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        max-width: @reading-width;
        font-family: 'Hanken Grotesk', sans-serif;
        font-weight: 700;
        margin-top: 12px;
        margin-bottom: 4px;
        line-height: 1.2;
    }
    h1 {
        font-size: 18px;
    }
    h2 {
        font-size: 16px;
    }
    h3 {
        font-size: 15px;
    }
    h4,
    h5,
    h6 {
        font-size: 14px;
    }

    p {
        max-width: @reading-width;
        margin-top: 0;
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 1.5;
    }

    ul,
    ol {
        max-width: @reading-width;
        padding-left: 20px;
        margin-bottom: 8px;
    }

    li {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 8px;
    }

    .fl_markdown_table();

    strong,
    b {
        font-weight: 700;
    }

    code {
        font-size: 12px;
        background-color: #f3f4f6;
        padding: 1px 4px;
        border-radius: 3px;
    }

    blockquote {
        max-width: @reading-width;
        border-left: 3px solid #eceef2;
        margin: 0 0 8px 0;
        padding-left: 12px;
        color: #6b7280;
        font-size: 13px;
    }
}

.citation_class {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    margin: 3px 4px 3px 0;
    font-size: 12px;
    font-weight: 500;
    color: #4a90e2;
    background-color: #f0f7ff;
    border: 1px solid #d0e7ff;
    border-radius: 4px;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    line-height: 1.4;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e0f0ff;
        border-color: #4a90e2;
        color: #2a70c2;
        text-decoration: none;
    }

    &:active {
        background-color: #d0e7ff;
    }
}
